// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__n1CI8","select":"Header_select__k_HKH","clinic":"Header_clinic__1bcDo"};